<template>
  <v-dialog v-model="show" max-width="600" transition="spin-in-out-transition">
    <v-card class="rounded-lg pb-4 card-wrapper position-relative">
      <v-icon large color="black" class="position-absolute right-2 top-2" @click="close">
        mdi-close
      </v-icon>
      <v-card-title class="justify-center text-h4 pb-0 font-weight-bold">
        {{ $t('systemNotification.receivedPoint.title') }}
      </v-card-title>
      <v-card-title class="justify-center pt-2 text-h3">
        <v-img
          width="400"
          src="@/assets/image/notification/new-message-slogan.png"
          class="flex-grow-0"
        />
      </v-card-title>
      <v-sheet
        class="px-2 mx-10 mt-12 mb-5 rounded-xl"
        color="white"
        style="border: medium solid black !important"
      >
        <div class="d-flex justify-center" style="margin-top: -40px">
          <v-avatar size="80" style="border: thin solid black !important">
            <v-img :src="$attrs.staffFrom.avatar" />
          </v-avatar>
        </div>
        <div class="text-center mt-2">
          <span class="text-h5 font-weight-black">
            {{ $attrs.staffFrom.name }}
          </span>
          <span class="font-weight-black">
            {{ $t('systemNotification.receivedPoint.given') }}
          </span>
        </div>
        <div class="deep-orange--text text-center">
          <span class="text-h1 font-weight-black">{{ $attrs.gift }}</span>
          <span class="text-h3 font-weight-black">{{ $t('common.coin') }}</span>
        </div>
        <div class="text-h5 font-weight-black text-center mb-5">
          {{ $t('systemNotification.receivedPoint.forYou') }}
        </div>
      </v-sheet>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="black"
          large
          dark
          class="text-h5 font-weight-black px-10 rounded-lg"
          depressed
          @click="closeAndRedirect"
        >
          {{ $t('systemNotification.receivedPoint.exchange') }}
        </v-btn>
        <v-spacer />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import templateMixin from './templateMixin';

export default {
  name: 'NewMessage',
  mixins: [templateMixin],
  methods: {
    /**
     * Close dialog and check if show thanks message dialog or not
     * @returns {Promise<void>}
     */
    async closeAndRedirect() {
      // Check if dialog send thank message is show 
      const dialogThankMessageState = this.$store.state.gift.thanksMessageDialog;
      // Router is not thanks/for-you
      const otherRouter = this.$route.fullPath !== '/thanks/for-you';

      if (dialogThankMessageState && otherRouter) {
        // Show confirm popup when user click confirm button if dialog is show
        const result = window.confirm(this.$t('systemNotification.popUp.confirm'));
        if (!result) {
          this.show = false;
          return;
        }
      }
      // Router is not thanks/for-you
      if (!otherRouter) {
        this.show = false;
        return;
      }

      await this.$store.commit('gift/setThanksMessageDialog', false);
      this.show = false;

      await new Promise((resolve) => setTimeout(resolve, 500));
      await this.$router.push('/thanks/for-you');
    },
  },
};
</script>

<style scoped lang="sass">
.card-wrapper
  background-image: url("../../../../assets/image/background/cheeers-new-message-bg.png")
  background-size: 300px
  background-repeat: repeat
</style>
